const theme = {
  fixedMenuWidth: "250px",
  fixedReqCardWidth: "270px",
};

export default theme;
